export default __webpack_public_path__ + "static/media/016-doctor.25237fad.svg";